import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter } from "@/components/ui/card"
import { Mail, Phone, Store } from "lucide-react"
import { useNavigate } from "react-router-dom"

const levels = {
  1: "Organizador",
  2: "Tienda Oficial",
  3: "Tienda Oficial Klu",
  4: "Tienda Legendaria",
}

const randomPlaceholderLogo = (id: number) => {
  const placeholders = [1, 2, 3, 4, 5]
  const lastDigit = id % 10
  const index = placeholders[lastDigit % placeholders.length]
  return `/img/placeholder-logo-tienda${index}.png`
}

export const StoreInfo = ({ store }) => {
  const navigate = useNavigate()
  if (!store) return null

  const level = levels[store.levelId]

  return (
    <Card className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 overflow-hidden">
      <CardContent className="p-0">
        {/* Header strip */}
        <div className="flex items-center justify-between gap-3 px-4 pt-4 pb-3 border-b border-muted/40 dark:border-gray-700">
          <div className="flex items-center gap-2">
            <Store className="h-4 w-4 text-muted-foreground shrink-0" />
            <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              {level ?? "Organizador"}
            </span>
          </div>
          {store.active ? (
            <Badge className="text-[10px] px-1.5 py-0 bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-400 border-0">
              Activa
            </Badge>
          ) : (
            <Badge className="text-[10px] px-1.5 py-0 bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400 border-0">
              Inactiva
            </Badge>
          )}
        </div>

        {/* Store identity */}
        <div className="flex items-center gap-3 px-4 py-3">
          <img
            src={store.urlLogo || randomPlaceholderLogo(store.id)}
            alt={store.name}
            className="h-14 w-14 rounded-xl object-cover border border-muted/30 dark:border-gray-600 shrink-0"
          />
          <div className="min-w-0">
            <h4 className="font-semibold text-sm leading-tight truncate">{store.name}</h4>
            {store.description && (
              <p className="mt-0.5 text-xs text-muted-foreground dark:text-gray-400 line-clamp-2">
                {store.description}
              </p>
            )}
          </div>
        </div>

        {/* Contact info */}
        {(store.phone || store.email) && (
          <div className="px-4 pb-3 space-y-1.5">
            {store.phone && (
              <div className="flex items-center gap-2 text-xs text-muted-foreground dark:text-gray-400">
                <Phone className="h-3.5 w-3.5 shrink-0" />
                <span>{store.phone}</span>
              </div>
            )}
            {store.email && (
              <div className="flex items-center gap-2 text-xs text-muted-foreground dark:text-gray-400">
                <Mail className="h-3.5 w-3.5 shrink-0" />
                <span className="truncate">{store.email}</span>
              </div>
            )}
          </div>
        )}
      </CardContent>

      <CardFooter className="px-4 pb-4 pt-0">
        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={() => navigate(store.urlView)}
        >
          Ver tienda
        </Button>
      </CardFooter>
    </Card>
  )
}
